import { render, staticRenderFns } from "./CustomInputNumber.vue?vue&type=template&id=6ba24bde&scoped=true&"
import script from "./CustomInputNumber.vue?vue&type=script&lang=js&"
export * from "./CustomInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputNumber.vue?vue&type=style&index=0&id=6ba24bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba24bde",
  null
  
)

export default component.exports